import first from "rfuncs/functions/first"
import get_header from "workflow/requests/get_header"

export default r =>
  first(get_header(r, "content-type").split(";")).toLowerCase()
